import React, { useState, useEffect, useRef } from "react";
import Loadspinner from "../../../common/Loadspinner";
import Main from "../../../common/Main/Main";
import InputForm from "../../../ReusableComponents/InputForm/InputForm";
import { APICall } from "../../../helpers/API/APICalls";
import {
  getUsefulLinkMasterDataById,
  insertUpdateUsefulLinkMaster,
} from "../../../helpers/API/APIEndPoints";
import moment from "moment";
import notify from "../../../ReusableComponents/ToastNotification/ToastNotification";
import { useHistory, useParams } from "react-router-dom";
import ErrorLabel from "../../../ReusableComponents/ErrorLabel/ErrorLabel";
import {
  saveRecordMsg,
  updateRecordMsg,
} from "../../../helpers/Constants/Constants";
import { Button, Card, Form, Image, InputGroup } from "react-bootstrap";
import { del } from "../../../constants/Images";
import { Modal } from "@material-ui/core";
import ButtonForm from "../../../ReusableComponents/ButtonForm/ButtonForm";
import CreateKnowledgeService from "../../../services/CreateKnowledgeService";
import { downloadBlob } from "../../../services/CommonService";
import SubmitButton from "../../../ReusableComponents/Buttons/SubmitButton/SubmitButton";
import ResetButton from "../../../ReusableComponents/Buttons/ResetButton/ResetButton";
import CancelButton from "../../../ReusableComponents/Buttons/CancelButton/CancelButton";
import Decrypt2 from "../../../helpers/Cryptography/CryptoJS";
import FormLabel from "../../../ReusableComponents/FormLabel/FormLabel";
import DeleteDialogueBox from "../../../ReusableComponents/DeleteDialogueBox/DeleteDialogueBox";
import CommonConstants from "../../../constants/CommonConstants";
import { getFromEncLocalStorage } from "../../../helpers/Utils/Utils";

const UesfulLinkMasterEdit = () => {
  let history = useHistory();
  // const { id: usefulLinkId } = useParams();
  const [loading, setLoading] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [editModeIsActive, setEditModeIsActive] = useState(true);
  const [editModeDisableButton, setEditModeDisableButton] = useState(true);
  const [showDeleteConfirmationModal, setShowDeleteConfirmationModal] =
    useState(false);
  const [fileToBeDeleted, setFileToBeDeleted] = useState(null);
  const [formErrors, setFormErrors] = useState({});
  const [Id, setId] = useState(0);

  const inputFileRef = useRef();
  const [files, setFiles] = useState([]);
  const [title, setTitle] = useState("");
  const [quicklink, setQuickLink] = useState("");
  const [sequence, setSequence] = useState();
  const [isActive, setIsActive] = useState(true);
  const [allowedFileTypes, setAllowedFileTypes] = useState("");
  let formErrorObj = {};
  let state_id = 0;

  useEffect(() => {
    (async () => {
      // state_id = usefulLinkId //history?.location?.state?.id;
      state_id = await Decrypt2(getFromEncLocalStorage("tokennumber")); //history?.location?.state?.id;
      if (state_id !== 0 || state_id != "0") {
        getUsefulLinkMasterDataByIdApiCall(state_id);
      }
    })();
  }, []);

  useEffect(() => {
    const allowedImagesFileTypesLS = getFromEncLocalStorage(
      "ImageFilesValidationExtension"
    );
    //const allowedVideoFileTypesLS = getFromEncLocalStorage("VideoFilesValidationExtension");
    if (allowedImagesFileTypesLS) {
      // || allowedVideoFileTypesLS) {
      setAllowedFileTypes(
        [
          ...allowedImagesFileTypesLS.split(","),
          //...allowedVideoFileTypesLS.split(',')
        ]
          .map((aift) => `.${aift}`)
          .join(",")
      );
    }
  }, []);

  const getUsefulLinkMasterDataByIdApiCall = async (id) => {
    setLoading(true);
    const data = await APICall(getUsefulLinkMasterDataById, { id: id }, "POST");

    if (data.message === "Ok") {
      if (data && data.data && data.data[0][0] && data.data[0][0].Id) {
        setId(data.data[0][0].Id);
        setTitle(data.data[0][0].Title);
        setQuickLink(data.data[0][0].QuickLink);
        setSequence(data.data[0][0].Sequence);
        setIsActive(data.data[0][0].IsActive);
        setEditModeIsActive(false);
        setEditModeDisableButton(false);
        let dataArr = data.data[0];
        let dataObj = dataArr[0];

        let filesTmp = [];
        // setFiles(filesTmp);
        for (let index = 0; index < dataArr?.length; index++) {
          dataObj = dataArr?.[index];

          if (dataObj.Image != null) {
            const fullResImgUrl = await downloadBlob(dataObj?.Image);
            const azureFileName = new URL(dataObj?.Image)?.pathname
              ?.split("/")
              ?.pop();
            filesTmp.push({
              localUrl: fullResImgUrl,
              blob: null,
              id: `img_${index}`,
              name: "",
              size: null,
              type: "",
              globalUrl: dataObj.Image,
              azureFileName: azureFileName,
              exists: true,
            });
          }
        }
        setFiles(filesTmp);
      }
      setLoading(false);
    } else {
      notify(1, data.message);
      setLoading(false);
    }
  };

  const onClickFunction = async (event, action) => {
    if (action === "Submit") {
      await checkValidations();
      const isEmpty = await Object.values(formErrorObj).every(
        (x) => x === null || x === "" || x === undefined
      );
      if (isEmpty) {
        setLoading(true);

        let filesTmp = [...files];
        for (let index = 0; index < filesTmp?.length; index++) {
          const file = filesTmp?.[index];
          if (!file?.globalUrl) {
            let resp = await saveImage(file.blob);
            let imgUrl = resp?.result?.[0];
            if (imgUrl) {
              file.globalUrl = imgUrl;
            }
          }
        }
        setFiles(filesTmp);

        let requestParams = {
          Id: Id,
          Title: title.replace(/\s+/g, " ").trim(),
          QuickLink: quicklink.replace(/\s+/g, " ").trim(),
          Sequence: sequence,
          IsActive: isActive,
          Attachments: filesTmp,
          CreatedDate: moment(new Date()).format("yyyy-MM-DD HH:mm:ss"),
          UserId: getFromEncLocalStorage("userId"), //UserId
        };
        console.log(requestParams);

        const res = await APICall(
          insertUpdateUsefulLinkMaster,
          requestParams,
          "POST"
        );
        if (res.message === "Ok") {
          if (res && res.data !== 0) {
            if (Id === 0) {
              notify(0, saveRecordMsg);
            } else if (Id > 0) {
              notify(0, updateRecordMsg);
            }
            history.push({ pathname: "/usefullink-master" });
          }
          setLoading(false);
        } else {
          notify(
            1,
            typeof res?.message === "string"
              ? res?.message
              : res?.message?.message
          );
          setLoading(false);
        }
        setLoading(false);
      }
    } else if (action === "Reset") {
      resetFunction();
    } else if (action === "Cancel") {
      history.push({ pathname: "/usefullink-master" });
    }
  };

  const resetFunction = () => {
    setFormErrors({});
    setTitle("");
    setQuickLink("");
    setSequence("");
    setFiles([]);
    formErrorObj = {};
  };

  const handleNumericEvent = async (event, field) => {
    var error = undefined;
    let tempName = event.target.value;
    var setError = "";
    if (field === "sequence") {
      await setSequence(tempName);
      setError = "Sequence";
    }

    if (tempName == undefined || tempName == null) {
      error = setError + " Cannot Be Empty";
    }

    setFormErrors((preState) => ({
      ...preState,
      [setError.replaceAll(" ", "") + "_isEmpty"]: error,
    }));
  };

  const handleTextEvent = async (event, field) => {
    var error = undefined;
    let tempName = event.target.value;
    var setError = "";
    if (field === "title") {
      setTitle(tempName);
      setError = "Title";
    }
    if (field === "quicklink") {
      setQuickLink(tempName);
      setError = "QuickLink";
    }

    if (tempName == undefined || tempName == null || tempName.trim() == "") {
      error = setError + " Cannot Be Empty";
    }

    setFormErrors((preState) => ({
      ...preState,
      [setError.replaceAll(" ", "") + "_isEmpty"]: error,
    }));
  };

  const isValidUrl = (urlString) => {
    var inputElement = document.createElement("input");
    inputElement.type = "url";
    inputElement.value = urlString;

    if (!inputElement.checkValidity()) {
      return false;
    } else {
      return true;
    }
  };

  const checkValidations = async () => {
    var objError = {};
    var setError = "";

    if (title == undefined || title == null || title.trim() == "") {
      setError = "Title";
      objError[setError.replaceAll(" ", "") + "_isEmpty"] =
        setError + " Cannot Be Empty";
    } else if (title.replace(/\s+/g, " ").trim().length >= 255) {
      setError = "Title";
      objError[setError.replaceAll(" ", "") + "_isEmpty"] =
        setError + " Is Longer Than The 255 Character";
    }

    if (quicklink == undefined || quicklink == null || quicklink.trim() == "") {
      setError = "QuickLink";
      objError[setError.replaceAll(" ", "") + "_isEmpty"] =
        setError + " Cannot Be Empty";
    } else if (quicklink.replace(/\s+/g, " ").trim().length >= 255) {
      setError = "QuickLink";
      objError[setError.replaceAll(" ", "") + "_isEmpty"] =
        setError + " Is Longer Than The 255 Character";
    } else if (!isValidUrl(quicklink)) {
      setError = "QuickLink";
      objError[setError.replaceAll(" ", "") + "_isEmpty"] =
        setError + " should be valid";
    }

    if (files.length <= 0) {
      objError["File_isEmpty"] = "Please Select Icon Image";
    }
    // setSequence
    // sequence
    //
    if (
      sequence == undefined ||
      sequence == null ||
      !/^[0-9]+$/.test(sequence)
    ) {
      objError["Sequence_isEmpty"] = "Sequence Should Be Numeric";
    }

    // image icon pending

    formErrorObj = objError;
    await setFormErrors(objError);
  };

  const onFileChange = (e) => {
    if (
      [...e?.target?.files].filter((f) => !f.type.startsWith("image")).length >
      0
    ) {
      notify(1, "Only images is allowed!");
      return;
    }
    const selectedFile = e.target.files[0];
    if (selectedFile && selectedFile.size >= 500 * 1024 * 1024) {
      notify(1, "Please select a file that is less than or equal to 5MB.");
      return;
    }

    // #region check file extension with config value
    const allowedFileTypesArr = [...allowedFileTypes?.split(",")];
    if (allowedFileTypesArr) {
      let isExtensionAllowed = true;
      let filesToCheck = [...e?.target?.files];
      for (let index = 0; index < filesToCheck.length; index++) {
        const fileToCheck = filesToCheck[index];
        isExtensionAllowed = allowedFileTypesArr.some((ext) =>
          fileToCheck?.name?.endsWith(ext)
        );
        if (!isExtensionAllowed) break;
      }
      if (!isExtensionAllowed) {
        notify(1, `Only ${allowedFileTypesArr?.join(", ")} files are allowed!`);
        return;
      }
    }
    // #endregion

    let filesTmp = [];
    for (let index = 0; index < e?.target?.files?.length; index++) {
      const file = e?.target?.files?.[index];
      console.log(e?.target?.files);
      if (file) {
        filesTmp.push({
          localUrl: URL.createObjectURL(file),
          blob: file,
          id: `img_${index}`,
          name: file.name,
          size: file.size,
          type: file.type,
        });
      }
    }
    setFiles(filesTmp);

    setFormErrors((preState) => ({
      ...preState,
      ["File_isEmpty"]: "",
    }));
  };

  const handleBtnClick = (e) => {
    inputFileRef.current.click();
  };

  const deleteImage = () => {
    setFiles([]);
    setShowDeleteConfirmationModal(false);
  };

  const saveImage = async (file) => {
    const formData = new FormData();
    formData.append("file", file);
    let resp = await CreateKnowledgeService.fileUpload(formData, "gallery");

    return resp;
  };

  return (
    <>
      <Main active={"usefullink_master"} removeContainer={true}>
        <Loadspinner filename="UesfulLinkMasterEdit.js" isLoading={loading} isMiddle="false" />
        <div className="eventGalleryEdit">
          <div className="col-lg-12">
            <div className="row">
              <div className="col-md-4">
                <h4 style={{ paddingLeft: "5px" }}>Master</h4>
              </div>
              <div className="clearfix"></div>
              <div
                className="d-flex align-items-center justify-space-between"
                style={{
                  background: "#e61636",
                  padding: "10px 20px 10px 10px",
                  color: "white",
                  width: "100%",
                }}
              >
                <div className="col-lg-8">Useful Links</div>
              </div>

              <div className="col-lg-12 col-md-12 mt-3">
                <div className="row">
                  <div className="col-lg-4 col-sm-4 col-xs-4 ">
                    <div className="form-group">
                      {/* <label className="col-form-label">Title</label> */}
                      <FormLabel value="Title" />
                      <sup>*</sup>
                      <InputForm
                        className="form-control form-control-sm"
                        placeholder={"Title"}
                        isDisabled={editMode ? true : false}
                        textArea={false}
                        value={title}
                        onChange={(e) => handleTextEvent(e, "title")}
                      />
                      {/* <p style={{ color: "red" }}>
                        {formErrors["Title_isEmpty"]}
                      </p> */}
                      <ErrorLabel value={formErrors["Title_isEmpty"]} />
                    </div>
                  </div>
                  <div className="col-lg-3 col-sm-4 col-xs-4 ">
                    <div className="form-group">
                      {/* <label className="col-form-label">Sequence</label> */}
                      <FormLabel value="Sequence" />
                      <sup>*</sup>
                      <InputForm
                        className="form-control form-control-sm"
                        placeholder={"Sequence"}
                        isDisabled={editMode ? true : false}
                        type="number"
                        textArea={false}
                        value={sequence}
                        onChange={(e) => handleNumericEvent(e, "sequence")}
                      />
                      {/* <p style={{ color: "red" }}>
                        {formErrors["Sequence_isEmpty"]}
                      </p> */}
                      <ErrorLabel value={formErrors["Sequence_isEmpty"]} />
                    </div>
                  </div>
                  <div className="col-lg-4 col-sm-4 col-xs-4 ">
                    <div className="form-group">
                      {/* <label className="col-form-label">Quick Link</label> */}
                      <FormLabel value="Quick Link" />
                      <sup>*</sup>
                      <InputForm
                        className="form-control form-control-sm"
                        placeholder={"Quick Link"}
                        isDisabled={editMode ? true : false}
                        textArea={false}
                        value={quicklink}
                        onChange={(e) => handleTextEvent(e, "quicklink")}
                      />
                      {/* <p style={{ color: "red" }}>
                        {formErrors["QuickLink_isEmpty"]}
                      </p> */}
                      <ErrorLabel value={formErrors["QuickLink_isEmpty"]} />
                    </div>
                  </div>
                </div>

                <div className="col-lg-12 col-md-12 mt-3">
                  <div className="row">
                    <div
                      className="col-lg-4 col-sm-4 col-xs-4"
                      style={{ position: "relative" }}
                    >
                      {/* <label className="col-form-label">Icon</label> */}
                      <FormLabel value="Icon" />
                      <sup className="required">*</sup>
                      <InputGroup className="mb-1">
                        <InputForm
                          className="form-control form-control-sm fileInputStyle"
                          placeholder={"images"}
                          isDisabled={false}
                          textArea={false}
                          onClick={handleBtnClick}
                          readOnly
                        />
                        <ButtonForm
                          variant="secondary"
                          id="button-addon2"
                          value="Browse"
                          onClick={handleBtnClick}
                        />
                      </InputGroup>
                      <input
                        type="file"
                        style={{ display: "none" }}
                        id="btn_event_gallery_master_file_input"
                        ref={inputFileRef}
                        onChange={onFileChange}
                        accept={allowedFileTypes}
                        autoComplete={CommonConstants.autoCompleteInput}
                      />
                      <span
                        style={{
                          fontSize: "12px",
                          position: "absolute",
                          right: "15px",
                        }}
                      >
                        Note: Image should be of 50x50 pixels
                      </span>
                      {/* <p style={{ color: "red" }}>
                        {formErrors["File_isEmpty"]}
                      </p> */}
                      <p style={{ position: "absolute", top: "86px" }}>
                        <ErrorLabel value={formErrors["File_isEmpty"]} />
                      </p>
                    </div>
                    <div className="col-lg-4 col-sm-4 col-xs-4">
                      <div className="form-group">
                        {/* <label className="col-form-label">Active Status</label> */}
                        <FormLabel value="Active Status" />
                        <div className="custom-checkbox">
                          <input
                            disabled={editModeIsActive ? true : false}
                            type="checkbox"
                            onChange={(e) => setIsActive(e.target.checked)}
                            name="isActive"
                            checked={isActive}
                            className="isActive"
                            autoComplete={CommonConstants.autoCompleteInput}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    {files?.map((file, fIdx) => {
                      return (
                        <Card
                          key={`img${fIdx}`}
                          className="col-lg-2 col-sm-2 col-xs-2 imgCard"
                          style={{ top: "15px" }}
                        >
                          <Card.Img
                            variant="top"
                            src={file?.localUrl}
                            className="gridImage"
                          />
                          <Card.Body className="imgCardBody">
                            <div className="row my-1">
                              <div className="col-lg-10 col-sm-10 col-xs-10 text-center">
                                <Card.Text>{file?.name}</Card.Text>
                              </div>
                              <div className="col-lg-2 col-sm-2 col-xs-2">
                                <Button variant="outline-light" size="sm">
                                  <Image
                                    src={del}
                                    className="delBtn"
                                    onClick={() => {
                                      setFileToBeDeleted(file);
                                      setShowDeleteConfirmationModal(true);
                                    }}
                                  />
                                </Button>
                              </div>
                            </div>
                          </Card.Body>
                        </Card>
                      );
                    })}
                  </div>
                </div>
              </div>

              {/* <div className="col-lg-12 col-md-12 mt-3">
                <div className="row" style={{color:"red"}}>
                  <p><strong>Note : Image should be of 50 X 50 pixels</strong></p>
                </div>
               </div> */}
              <div className="col-lg-12 col-md-12 mt-3">
                <div className="row">
                  <div className="col-lg-11 col-md-11" style={{ width: "97%" }}>
                    <div className="float-right">
                      <SubmitButton
                        onClick={(e) => onClickFunction(e, "Submit")}
                      />
                      {editModeDisableButton && (
                        <ResetButton
                          onClick={(e) => onClickFunction(e, "Reset")}
                        />
                      )}

                      <CancelButton
                        onClick={(e) => onClickFunction(e, "Cancel")}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* <Modal
          open={showDeleteConfirmationModal}
          onClose={() => setShowDeleteConfirmationModal(false)}
          className="modal-dialog modal-dialog-centered"
        >
          <div className="modal-content logout-modal">
            <div className="modal-body">
              Are you sure you want to delete this image?
            </div>
            <div className="display-row justify-space-evenly">
              <button
                className="btn btn-secondary"
                type="button"
                onClick={() => {
                  setFileToBeDeleted(null);
                  setShowDeleteConfirmationModal(false);
                }}
              >
                Cancel
              </button>
             
              <button
                className="btn btn-danger"
                type="button"
                onClick={() => deleteImage()}
              >
                Delete
              </button>
            
            </div>
          </div>
        </Modal> */}
        <DeleteDialogueBox
          open={showDeleteConfirmationModal}
          close={() => setShowDeleteConfirmationModal(false)}
          cancel={() => {
            setFileToBeDeleted(null);
            setShowDeleteConfirmationModal(false);
          }}
          deleteImage={() => deleteImage()}
        />
      </Main>
    </>
  );
};

export default UesfulLinkMasterEdit;
